(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blueprint-product"]) return;
  try {
    
if(!customElements.get('blueprint-product'))customElements.define('blueprint-product',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();const signal=this.controller.signal;
  this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.form=this.querySelector('.bp-form');this.select=this.querySelector('[name="id"]');this.quantity=this.querySelector('[name="quantity"]');this.groups=[...this.querySelectorAll('[data-option-index]')];this.format=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});this.classList.add('is-ready');
  this.addEventListener('change',e=>{if(e.target.matches('.bp-option-values input')){let options=this.groups.map(g=>g.querySelector('input:checked')?.value);let v=this.variants.find(v=>v.options.every((o,i)=>o===options[i]));this.select.value=v?.id||'';this.update(true)}else if(e.target===this.select){this.update(true)}else if(e.target.name?.startsWith('bp-bundle-')){this.quantity.value=e.target.value;this.update()}else if(e.target===this.quantity||e.target.matches('[data-addon]'))this.update()},{signal});
  this.addEventListener('click',e=>{const thumb=e.target.closest('[data-show-media]');if(thumb)this.showMedia(thumb.dataset.showMedia)},{signal});
  this.form.addEventListener('submit',e=>this.submit(e),{signal});
  this.mediaObserver=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting){this.querySelectorAll('[data-show-media]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.showMedia===entry.target.dataset.media)));this.querySelectorAll('.bp-gallery__slide video').forEach(v=>{if(!entry.target.contains(v))v.pause()})}},{root:this.querySelector('.bp-gallery__stage'),threshold:.6});this.querySelectorAll('[data-media]').forEach(m=>this.mediaObserver.observe(m));
  const sticky=this.querySelector('.bp-sticky');if(sticky){this.stickyObserver=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0},{threshold:0});this.stickyObserver.observe(this.form.querySelector('.bp-add'))}
  this.update();
  const clock=this.querySelector('[data-offer-end]');if(clock){const end=Date.parse(clock.dataset.offerEnd),tick=()=>{const seconds=Math.floor((end-Date.now())/1000);clock.hidden=!(seconds>0);if(seconds>0){const days=Math.floor(seconds/86400),hours=Math.floor(seconds%86400/3600),minutes=Math.floor(seconds%3600/60);clock.querySelector('time').textContent=(days?days+'d ':'')+[hours,minutes,seconds%60].map(v=>String(v).padStart(2,'0')).join(':')}else clearInterval(this.clockTimer)};if(Number.isFinite(end)){tick();this.clockTimer=setInterval(tick,1000)}}
 }
 disconnectedCallback(){this.controller?.abort();clearInterval(this.clockTimer);this.mediaObserver?.disconnect();this.stickyObserver?.disconnect()}
 money(value){return this.format.format(value/100)}
 showMedia(id){const slide=[...this.querySelectorAll('[data-media]')].find(m=>m.dataset.media===String(id));if(slide)this.querySelector('.bp-gallery__stage').scrollTo({left:slide.offsetLeft-this.querySelector('.bp-gallery__stage').offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
 update(navigate=false){
  const v=this.variants.find(v=>String(v.id)===this.select.value);this.variant=v;
  const min=v?.min||1,step=v?.step||1,max=Math.min(v?.max??Infinity,v?.inventory??Infinity);this.quantity.min=min;this.quantity.step=step;if(Number.isFinite(max))this.quantity.max=max;else this.quantity.removeAttribute('max');
  let quantity=Math.max(min,Number(this.quantity.value)||min);quantity=min+Math.ceil((quantity-min)/step)*step;if(max>=min)quantity=Math.min(quantity,min+Math.floor((max-min)/step)*step);this.quantity.value=quantity;
  this.groups.forEach((g,i)=>{g.querySelector('[data-option-name]').textContent=g.querySelector('input:checked')?.value||'';g.querySelectorAll('input').forEach(input=>{input.disabled=!this.variants.some(candidate=>candidate.options[i]===input.value&&candidate.options.slice(0,i).every((o,j)=>o===this.groups[j].querySelector('input:checked')?.value))})});
  const available=!!v?.available&&max>=min;this.querySelectorAll('.bp-add').forEach(b=>b.disabled=!available||this.busy);this.form.querySelector('[data-add-label]').textContent=v?(available?this.labels.add:this.labels.sold):this.labels.unavailable;
  this.querySelector('[data-price]').textContent=v?this.money(v.price):'—';const compare=this.querySelector('[data-compare]'),saving=this.querySelector('[data-saving]');compare.hidden=saving.hidden=!(v?.compare_at_price>v?.price);if(!compare.hidden){compare.textContent=this.money(v.compare_at_price);saving.textContent=this.labels.save+' '+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%'}
  this.querySelectorAll('[data-bundle-price]').forEach(el=>{const count=Number(el.dataset.bundlePrice),input=el.closest('label').querySelector('input');el.textContent=v?this.money(v.price*count):'—';input.disabled=!available||count<min||count>max||(count-min)%step!==0;input.checked=count===quantity&&!input.disabled});
  const addonTotal=[...this.querySelectorAll('[data-addon]:checked')].reduce((sum,input)=>sum+Number(input.dataset.price),0),total=(v?.price||0)*quantity+addonTotal;this.querySelector('[data-total]').textContent=v?this.money(total):'—';const stickyPrice=this.querySelector('[data-sticky-price]');if(stickyPrice)stickyPrice.textContent=v?this.money(total):'—';const stickyAdd=this.querySelector('[data-sticky-add]');if(stickyAdd)stickyAdd.textContent=v?(available?this.labels.add:this.labels.sold):this.labels.unavailable;
  const stock=this.querySelector('[data-stock]');if(stock){stock.hidden=!(v?.inventory>0&&v.inventory<=Number(stock.dataset.threshold));stock.textContent=v?.inventory+' '+this.labels.stock;}const dynamic=this.querySelector('.bp-dynamic');if(dynamic)dynamic.hidden=!available||addonTotal>0;
  if(navigate){const url=new URL(location.href);if(v){url.searchParams.set('variant',v.id);history.replaceState({},'',url);if(v.media)this.showMedia(v.media)}else{url.searchParams.delete('variant');history.replaceState({},'',url)}}
 }
 async submit(event){event.preventDefault();if(this.busy||!this.variant?.available||!this.form.reportValidity())return;this.busy=true;this.update();const status=this.querySelector('.bp-form-status');status.textContent=this.labels.adding;
  try{const addons=[...this.querySelectorAll('[data-addon]:checked')],headers={Accept:'application/json'};let body=new FormData(this.form);if(addons.length){headers['Content-Type']='application/json';body=JSON.stringify({items:[{id:this.variant.id,quantity:Number(this.quantity.value)},...addons.map(input=>({id:Number(input.dataset.id),quantity:1}))]})}const response=await fetch(this.dataset.cartUrl+'.js',{method:'POST',headers,body});const data=await response.json();if(!response.ok)throw new Error(typeof data.description==='string'?data.description:this.labels.error);status.textContent=this.labels.added;const trigger=document.querySelector('.cart-trigger-btn,.cart-trigger');if(trigger)trigger.click();else location.assign((window.Shopify?.routes?.root||'/')+'cart')}
  catch(error){status.textContent=error.message||this.labels.error}finally{this.busy=false;this.update()}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aura-hero-video')) {
  customElements.define('aura-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.hero-section');
      this.slides = [...this.section.querySelectorAll('.hero-slide')];
      this.videos = [...this.section.querySelectorAll('.hero-background-video')];
      this.button = this.section.querySelector('.hero-video-toggle');
      this.pausedByUser = new WeakSet();
      this.startedByUser = new WeakSet();
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      const options = { signal: this.abort.signal };
      this.refreshButton = () => {
        const video = this.section.querySelector('.hero-slide.active .hero-background-video');
        this.button.hidden = !video;
        const playing = video && !video.paused;
        this.button.classList.toggle('is-playing', Boolean(playing));
        this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
      };
      this.update = () => {
        const active = this.section.querySelector('.hero-slide.active .hero-background-video');
        this.videos.forEach(video => {
          const autoplay = video.closest('.hero-video-layer').dataset.autoplay === 'true';
          const play = video === active && this.inView && !document.hidden && !this.pausedByUser.has(video) && (this.startedByUser.has(video) || (autoplay && !this.motion.matches));
          if (play && video.paused) video.play().catch(this.refreshButton);
          else if (!play && !video.paused) video.pause();
        });
        this.refreshButton();
      };
      this.videos.forEach(video => {
        video.muted = true;
        video.playsInline = true;
        video.addEventListener('play', this.refreshButton, options);
        video.addEventListener('pause', this.refreshButton, options);
      });
      this.button.addEventListener('click', () => {
        const video = this.section.querySelector('.hero-slide.active .hero-background-video');
        if (!video) return;
        if (video.paused) {
          this.pausedByUser.delete(video);
          this.startedByUser.add(video);
          video.play().catch(this.refreshButton);
        } else {
          this.pausedByUser.add(video);
          video.pause();
        }
      }, options);
      document.addEventListener('visibilitychange', this.update, options);
      this.motion.addEventListener('change', this.update, options);
      this.slideObserver = new MutationObserver(this.update);
      this.slides.forEach(slide => this.slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] }));
      this.viewportObserver = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0.1 });
      this.viewportObserver.observe(this.section);
      this.refreshButton();
    }
    disconnectedCallback() {
      this.abort.abort();
      this.slideObserver.disconnect();
      this.viewportObserver.disconnect();
      this.videos.forEach(video => video.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-bundle-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bundle-offer-clock')) {
 customElements.define('bundle-offer-clock', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   clearTimeout(this.timer);
   this.controller = new AbortController();
   this.output = this.querySelector('[data-clock-time]');
   this.label = this.querySelector('[data-clock-label]');
   this.ended = this.querySelector('[data-clock-ended]');
   this.icon = this.querySelector('[aria-hidden="true"]');
   const minutes = Math.max(1, Math.min(60, Math.round(Number(this.dataset.duration) || 15)));
   const preview = this.dataset.editor === 'true';
   const key = 'aura:bundle-countdown:' + this.dataset.key + ':' + minutes;
   const note = this.querySelector('[data-clock-preview]');
   if (note) note.hidden = !preview;
   if (preview) this.end = Date.now() + minutes * 60000;
   else {
    let saved;
    try { saved = sessionStorage.getItem(key); } catch {}
    const stored = saved ? Number(saved) : NaN;
    if (Number.isFinite(stored) && stored > 0) this.end = stored;
    else {
     if (this.clockKey !== key || !Number.isFinite(this.end)) this.end = Date.now() + minutes * 60000;
     try { sessionStorage.setItem(key, String(this.end)); } catch {}
    }
   }
   this.clockKey = key;
   this.hidden = false;
   document.addEventListener('visibilitychange', () => this.tick(), {signal: this.controller.signal});
   window.addEventListener('pagehide', () => clearTimeout(this.timer), {signal: this.controller.signal});
   window.addEventListener('pageshow', () => this.tick(), {signal: this.controller.signal});
   this.tick();
  }
  tick() {
   clearTimeout(this.timer);
   if (!this.isConnected) return;
   const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
   const expired = remaining === 0;
   this.hidden = expired && this.dataset.expired === 'hide';
   this.label.hidden = expired;
   this.output.hidden = expired;
   this.ended.hidden = !expired;
   const digits = this.querySelector('.bundle-countdown__digits');
   if (digits) digits.hidden = expired;
   if (this.icon) this.icon.hidden = expired;
   const hours = Math.floor(remaining / 3600), minutes = Math.floor(remaining % 3600 / 60), seconds = remaining % 60;
   this.output.textContent = (hours || this.dataset.segmented === 'true' ? [hours, minutes, seconds] : [minutes, seconds]).map(value => String(value).padStart(2,'0')).join(':');
   this.output.setAttribute('datetime', 'PT' + remaining + 'S');
   if (!expired && !document.hidden) this.timer = setTimeout(() => this.tick(), 1000);
  }
  disconnectedCallback() {
   clearTimeout(this.timer);
   this.controller?.abort();
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-color-picker"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('product-color-picker')){
 class ProductColorPicker extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
   this.product=JSON.parse(this.querySelector('[data-picker-product]').textContent);this.labels=JSON.parse(this.querySelector('[data-picker-labels]').textContent);this.master=this.querySelector('.pcp-master');this.primary=this.product.variants.find(v=>v.id===this.master.value)||this.product.variants[0];this.colorIndex=Math.max(0,this.product.options.findIndex(name=>/colou?r/i.test(name)));
   const swatches=this.querySelector('.pcp-swatches');swatches.replaceChildren();
   for(const color of new Set(this.product.variants.map(v=>v.options[this.colorIndex]))){const variants=this.product.variants.filter(v=>v.options[this.colorIndex]===color),variant=variants.find(v=>v.available)||variants[0],button=document.createElement('button');button.type='button';button.dataset.color=color;button.setAttribute('aria-label',this.labels.color+': '+color);button.disabled=!variants.some(v=>v.available);if(variant.image||this.product.image){const image=document.createElement('img');image.src=variant.image||this.product.image;image.alt='';image.width=60;image.height=60;button.append(image)}else button.textContent=color;button.addEventListener('click',()=>{const matching=variants.find(v=>v.available&&v.options.every((value,i)=>i===this.colorIndex||value===this.primary.options[i]))||variants.find(v=>v.available);if(matching)this.select(matching)},{signal});swatches.append(button)}
   this.master.addEventListener('change',()=>this.render(),{signal});document.addEventListener('change',event=>{if(event.target.closest('product-module')?.dataset.product===this.product.id&&event.target.matches('.bp-variant-select,.bp-option-values input'))this.render()},{signal});this.querySelector('.pcp-enhanced').hidden=false;this.render();
   customElements.whenDefined('product-module').then(()=>{if(!this.isConnected)return;const wanted=this.dataset.defaultColor.trim().toLowerCase(),hasVariant=Boolean(this.dataset.selectedVariant),preferred=this.product.variants.find(v=>v.available&&v.options[this.colorIndex]?.toLowerCase()===wanted);if(wanted&&!hasVariant&&preferred)this.select(preferred);else this.render()});
  }
  select(variant){this.master.value=variant.id;this.master.dispatchEvent(new Event('change',{bubbles:true}))}
  render(){const variant=this.product.variants.find(v=>v.id===this.master.value);if(!variant)return;this.primary=variant;this.querySelector('[data-color-name]').textContent=variant.options[this.colorIndex]||variant.title;for(const button of this.querySelectorAll('[data-color]'))button.setAttribute('aria-pressed',String(button.dataset.color===variant.options[this.colorIndex]))}
  disconnectedCallback(){this.abort?.abort()}
 }
 customElements.define('product-color-picker',ProductColorPicker);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-delivery-timeline"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('delivery-timeline')) {
 customElements.define('delivery-timeline', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const signal = this.controller.signal;
   document.addEventListener('visibilitychange', () => this.refreshDates(), {signal});
   window.addEventListener('pageshow', () => this.refreshDates(), {signal});
   window.addEventListener('pagehide', () => clearTimeout(this.timer), {signal});
   this.refreshDates();
  }
  addDays(base, amount) {
   const date = new Date(base);
   let remaining = amount;
   while (remaining > 0) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (this.dataset.businessDays !== 'true' || ![0, 6].includes(date.getUTCDay())) remaining--;
   }
   return date;
  }
  formatDate(date, year) {
   const locale = this.dataset.locale || 'en';
   if (/^en(?:-|$)/i.test(locale)) {
    const day = date.getUTCDate();
    const suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({1:'st',2:'nd',3:'rd'}[day % 10] || 'th');
    return new Intl.DateTimeFormat(locale, {month:'short', timeZone:'UTC'}).format(date) + ' ' + day + suffix + (year ? ', ' + date.getUTCFullYear() : '');
   }
   return new Intl.DateTimeFormat(locale, {month:'short',day:'numeric',...(year ? {year:'numeric'} : {}),timeZone:'UTC'}).format(date);
  }
  refreshDates() {
   clearTimeout(this.timer);
   if (!this.isConnected) return;
   const now = new Date();
   const today = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
   const offset = key => Math.max(0, Math.min(60, Math.round(Number(this.dataset[key]) || 0)));
   const readyMin = offset('readyMin'), readyMax = Math.max(readyMin, offset('readyMax'));
   const deliveryMin = Math.max(readyMax, offset('deliveryMin')), deliveryMax = Math.max(deliveryMin, offset('deliveryMax'));
   const dates = [[today,today],[this.addDays(today,readyMin),this.addDays(today,readyMax)],[this.addDays(today,deliveryMin),this.addDays(today,deliveryMax)]];
   this.querySelectorAll('[data-step]').forEach((step,index) => {
    const [start,end] = dates[index], showYear = start.getUTCFullYear() !== today.getUTCFullYear() || end.getUTCFullYear() !== today.getUTCFullYear();
    const from = step.querySelector('[data-date-start]'), to = step.querySelector('[data-date-end]'), same = start.getTime() === end.getTime();
    from.textContent = this.formatDate(start,showYear); from.dateTime = start.toISOString().slice(0,10);
    to.textContent = this.formatDate(end,showYear); to.dateTime = end.toISOString().slice(0,10);
    to.hidden = same; step.querySelector('[data-date-dash]').hidden = same;
   });
   if (!document.hidden) {
    const midnight = new Date(now.getFullYear(),now.getMonth(),now.getDate()+1);
    this.timer = setTimeout(() => this.refreshDates(), midnight.getTime() - now.getTime() + 100);
   }
  }
  disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-summary-wellness"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('simulated-viewers')) {
  customElements.define('simulated-viewers', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      this.controller = new AbortController();
      const number = (value, fallback) => Number.isFinite(Number(value)) ? Math.round(Number(value)) : fallback;
      this.minimum = Math.max(1, number(this.dataset.min, 10));
      this.maximum = Math.max(this.minimum, number(this.dataset.max, 20));
      this.count = Math.min(this.maximum, Math.max(this.minimum, number(this.dataset.start, 15)));
      this.interval = Math.max(5, number(this.dataset.interval, 8)) * 1000;
      this.output = this.querySelector('[data-viewer-count]');
      this.renderCount();
      this.visible = true;
      if ('IntersectionObserver' in window) {
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);
      }
      document.addEventListener('visibilitychange', () => this.schedule(), {signal: this.controller.signal});
      window.addEventListener('pagehide', () => clearTimeout(this.timer), {signal: this.controller.signal});
      window.addEventListener('pageshow', () => this.schedule(), {signal: this.controller.signal});
      this.schedule();
    }
    renderCount() {
      if (!this.output) return;
      const template = this.count === 1 ? this.dataset.one : this.dataset.many;
      this.output.textContent = (template || '').replaceAll('__COUNT__', String(this.count));
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || document.hidden || !this.visible || this.minimum === this.maximum) return;
      this.timer = setTimeout(() => {
        const direction = this.count <= this.minimum ? 1 : this.count >= this.maximum ? -1 : Math.random() < 0.5 ? -1 : 1;
        this.count += direction;
        this.renderCount();
        this.schedule();
      }, this.interval * (1 + Math.random() * 0.5));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-proof"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('product-proof'))customElements.define('product-proof',class extends HTMLElement{connectedCallback(){this.controller=new AbortController();const signal=this.controller.signal,track=this.querySelector('.bp-proof__track'),prev=this.querySelector('[data-proof-prev]'),next=this.querySelector('[data-proof-next]');const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};this.addEventListener('input',e=>{if(e.target.matches('[data-comparison]'))e.target.closest('.bp-proof__comparison').style.setProperty('--comparison',e.target.value+'%')},{signal});this.addEventListener('click',e=>{const dir=e.target.closest('[data-proof-next]')?1:e.target.closest('[data-proof-prev]')?-1:0;if(dir)track.scrollBy({left:dir*((track.querySelector('article')?.offsetWidth||280)+18),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})},{signal});this.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>{this.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause()})},{signal}));track.addEventListener('scroll',update,{signal,passive:true});this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(track);update()}disconnectedCallback(){this.controller?.abort();this.resizeObserver?.disconnect()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('product-related'))customElements.define('product-related',class extends HTMLElement{connectedCallback(){if(this.querySelector('article')||this.loaded)return;this.loaded=true;if(this.hidden){this.load();return}this.observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){this.observer.disconnect();this.load()}},{rootMargin:'500px'});this.observer.observe(this)}async load(){try{const response=await fetch(this.dataset.url);if(!response.ok)return;const doc=new DOMParser().parseFromString(await response.text(),'text/html'),incoming=doc.querySelector('product-related .bp-related__grid');if(incoming?.querySelector('article')){this.querySelector('.bp-related__grid').replaceWith(incoming);this.hidden=false}else if(!window.Shopify?.designMode)this.hidden=true}catch(error){if(!window.Shopify?.designMode)this.hidden=true}}disconnectedCallback(){this.observer?.disconnect()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-thumbnail-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('product-thumbnail-gallery')){
 class ProductThumbnailGallery extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
   this.stage=this.querySelector('.ptg__stage');this.slides=[...this.querySelectorAll('[data-gallery-slide]')];this.thumbs=[...this.querySelectorAll('[data-gallery-index]')];this.previous=this.querySelector('[data-gallery-previous]');this.next=this.querySelector('[data-gallery-next]');this.index=0;
   if(this.slides.length<2)return;
   this.classList.add('is-ready');
   this.addEventListener('click',event=>{const thumb=event.target.closest('[data-gallery-index]');if(thumb&&this.contains(thumb)){event.preventDefault();this.show(Number(thumb.dataset.galleryIndex))}else if(event.target.closest('[data-gallery-previous]'))this.show(this.index-1);else if(event.target.closest('[data-gallery-next]'))this.show(this.index+1)},{signal});
   this.stage.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();this.show(event.key==='Home'?0:event.key==='End'?this.slides.length-1:this.index+(event.key==='ArrowRight'?1:-1))},{signal});
   this.stage.addEventListener('scroll',()=>{clearTimeout(this.scrollTimer);this.scrollTimer=setTimeout(()=>this.update(Math.round(this.stage.scrollLeft/this.stage.clientWidth)),100)},{signal,passive:true});
   document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('[data-gallery-slide]');if(slide&&this.contains(slide))this.show(this.slides.indexOf(slide))},{signal});
   this.resizeObserver=new ResizeObserver(()=>{this.stage.scrollTo({left:this.index*this.stage.clientWidth,behavior:'instant'})});this.resizeObserver.observe(this.stage);this.update(0);
  }
  show(index){index=Math.max(0,Math.min(this.slides.length-1,index));this.update(index);this.stage.scrollTo({left:index*this.stage.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
  update(index){this.index=Math.max(0,Math.min(this.slides.length-1,index));this.thumbs.forEach((thumb,i)=>{if(i===this.index)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current')});this.previous.disabled=this.index===0;this.next.disabled=this.index===this.slides.length-1;const thumb=this.thumbs[this.index],track=this.querySelector('.ptg__thumbnails');track.scrollTo({left:thumb.offsetLeft-track.offsetLeft-(track.clientWidth-thumb.clientWidth)/2,behavior:'instant'});this.querySelector('.ptg__status').textContent=thumb.getAttribute('aria-label')}
  disconnectedCallback(){this.controller?.abort();this.resizeObserver?.disconnect();clearTimeout(this.scrollTimer)}
 }
 customElements.define('product-thumbnail-gallery',ProductThumbnailGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aura-review-cards')) {
  customElements.define('aura-review-cards', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.aura-review-cards__track');
      this.buttons = Array.from(this.querySelectorAll('[data-review-direction]'));
      if (!this.track) return;
      this.update = () => {
        const cards = Array.from(this.track.children);
        const box = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this).direction === 'rtl';
        const first = cards[0]?.getBoundingClientRect();
        const last = cards.at(-1)?.getBoundingClientRect();
        this.buttons[0].disabled = !first || (rtl ? first.right <= box.right + 2 : first.left >= box.left - 2);
        this.buttons[1].disabled = !last || (rtl ? last.left >= box.left - 2 : last.right <= box.right + 2);
      };
      this.click = event => {
        const button = event.target.closest('[data-review-direction]');
        if (!button || button.disabled) return;
        const card = this.track.firstElementChild;
        const distance = (card?.getBoundingClientRect().width || this.track.clientWidth) + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({left: Number(button.dataset.reviewDirection) * distance * (getComputedStyle(this).direction === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.select = event => {
        const card = event.target.closest('.aura-review-cards__card');
        if (card && this.contains(card)) card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      };
      this.addEventListener('click', this.click);
      this.addEventListener('shopify:block:select', this.select);
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.click);
      this.removeEventListener('shopify:block:select', this.select);
      this.track?.removeEventListener('scroll', this.update);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-real-reels"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aura-watch-real')) {
  customElements.define('aura-watch-real', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.videos = Array.from(this.querySelectorAll('video'));
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.intersectionRatio < 0.5) entry.target.pause(); });
      }, { threshold: [0, 0.5] });
      this.videos.forEach((video, index) => {
        const button = video.parentElement.querySelector('button');
        if (!button) return;
        video.id = `${this.id}-video-${index}`;
        button.setAttribute('aria-controls', video.id);
        const update = () => {
          button.setAttribute('aria-pressed', String(!video.paused));
          button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        };
        const toggle = () => {
          if (video.paused) video.play().catch(() => { video.controls = true; button.hidden = true; });
          else video.pause();
        };
        button.addEventListener('click', toggle, options);
        video.addEventListener('click', toggle, options);
        video.addEventListener('play', () => {
          document.dispatchEvent(new CustomEvent('aura-watch-real:play', { detail: video }));
          update();
        }, options);
        video.addEventListener('pause', update, options);
        video.addEventListener('error', () => { video.controls = true; button.hidden = true; }, options);
        video.controls = false;
        button.hidden = false;
        update();
        this.observer.observe(video);
      });
      document.addEventListener('aura-watch-real:play', event => {
        this.videos.forEach(video => { if (video !== event.detail) video.pause(); });
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.videos.forEach(video => video.pause());
      }, options);
    }
    disconnectedCallback() {
      this.videos.forEach(video => video.pause());
      this.observer.disconnect();
      this.abort.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
